<template>
  <div class="app-field" :class="{ 'app-field--invalid': state === false, 'app-field--valid': state === true, 'app-field--required': required }">
    <slot name="label">
      <label v-if="label" class="app-field__label">
        {{ label }}<span v-if="required" class="app-field__required-mark">*</span>
      </label>
    </slot>
    <div class="app-field__content">
      <slot></slot>
    </div>
    <slot name="description">
      <small v-if="description" class="app-field__description">{{ description }}</small>
    </slot>
    <slot name="invalid-feedback">
      <div v-if="invalidFeedback && state === false" class="app-field__invalid-feedback">
        {{ invalidFeedback }}
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'AppField',
  props: {
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    invalidFeedback: {
      type: String,
      default: ''
    },
    state: {
      type: Boolean,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.app-field {
  margin-bottom: 1rem;
}

.app-field__label {
  display: block;
  margin-bottom: 0.125rem;
  font-weight: 600;
  color: var(--app-text-color, #374151);
  font-size: 0.875rem;
}

.app-field__required-mark {
  color: var(--app-danger, #dc3545);
  margin-left: 0.125rem;
}

.app-field__content {
  position: relative;
}

.app-field__description {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.app-field__invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--app-danger, #dc3545);
}

.app-field--invalid ::v-deep .app-input,
.app-field--invalid ::v-deep .app-textarea,
.app-field--invalid ::v-deep .app-select {
  border-color: var(--app-danger, #dc3545);
}

.app-field--invalid ::v-deep .app-input:focus,
.app-field--invalid ::v-deep .app-textarea:focus,
.app-field--invalid ::v-deep .app-select:focus {
  box-shadow: 0 0 0 0.2rem var(--app-danger-focus, rgba(220, 53, 69, 0.25));
}
</style>
